<template>
  <div>
    <b-button
      id="toggleColumns"
      size="sm"
      @click="show = !show"
    >
      <font-awesome-icon :icon="['fas', 'columns']" />
      Columns
    </b-button>
    <b-popover
      id="toggleColumnsPopover"
      :show.sync="show"
      target="toggleColumns"
      placement="bottom"
      triggers="click blur"
    >
      <section>
        <draggable
          :list="columns"
          handle=".handle"
          @change="columnOrdering"
        >
          <div
            v-for="column in columns"
            :key="column.fieldGuid"
            class="d-flex align-items-center mb-2"
            :data-column="column.name"
          >
            <font-awesome-icon
              :icon="['fas', 'grip-vertical']"
              class="handle mr-2"
            />
            <b-form-checkbox
              v-model="column.checked"
              class="mr-1"
              :disabled="column.name === groupBy || column.name === subGroupBy"
            >
              {{ column.displayName }}
            </b-form-checkbox>
          </div>
        </draggable>
      </section>
      <footer class="flex justify-content-end">
        <b-button
          id="saveToggleColumns"
          size="sm"
          @click="onSaveClick"
        >
          Save
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          class="ml-2"
          @click="show = false"
        >
          Cancel
        </b-button>
      </footer>
    </b-popover>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import draggable from 'vuedraggable';
import ContentSpinner from '../../../../core/components/ContentSpinner.vue';

const {
  mapState,
  mapActions,
} = createNamespacedHelpers('dataManagement');

export default {
  name: 'ToggleColumnsButton',
  components: {
    ContentSpinner,
    draggable,
  },
  props: {
    fields: {},
    toggleColumns: {},
    groupBy: {},
    subGroupBy: {},
  },
  data() {
    return {
      show: false,
      columns: [],
      loading: false,
      disableSubmitButton: false,
    };
  },
  watch: {
    toggleColumns: {
      handler() {
        this.populateToggleColumns();
      },
      immediate: true,
    },
    fields: {
      handler() {
        this.populateToggleColumns();
      },
      immediate: true,
    },

  },
  computed: {
    ...mapState({
      modal: state => state.addEditModal,
      modalData: state => state.addEditModal.data,
    }),
    isEditMode() {
      return !!Object.keys(this.modalData).length;
    },
  },
  methods: {
    populateToggleColumns() {
      const myMap = new Map();
      if (this.toggleColumns) {
        this.toggleColumns.forEach((obj) => {
          myMap.set(obj.guid, obj.checked);
        });
      }
      this.columns = [...this.fields].map(f => {
        if (!this.toggleColumns) {
          f.checked = true;
        } else {
          f.checked = !!myMap.get(f.fieldGuid);
        }

        return f;
      });
    },
    columnOrdering() {
    },
    onSaveClick() {
      this.$emit('change', this.columns);
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#toggleColumnsPopover {
  font-size: 0.9rem;
  width: 200px;

  /deep/ .popover-body {
    padding: 0;

    & section {
      padding-bottom: 0;
      max-height: 250px;
      overflow: auto;
    }
  }

  section {
    padding: 1rem;
  }

  footer {
    padding: 0.75rem;
    background-color: #f1f1f1;
  }
}
</style>
